module.exports = __webpack_public_path__ + "img/map_Z3.2.A.01.9c68f67b.svg";